export default __webpack_public_path__ + "static/media/Swiss721BTBold.b7cf72fb.woff";